import { HomeMsg } from '@gateway.Home'
import { yamadumiApi } from '../yamadumi-api'

/**
 * メッセージ登録
 */
export class PutMessageGateway {
  static loginMsg = async (params: HomeMsg) => {
    return await yamadumiApi.put('/api/common/message', { data: params })
  }
}
